import { Row, Col } from "antd";
import moment from 'moment';
import { currencyFormat } from "../../../../../../helpers/utilities";

export const ChallanFormat = (props) => {
    const { details, clsx, classes } = props;

    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }

    return (
        <div className={clsx(classes.printFullPage, classes.formatSecond, 'pagebreak')} data-invoiceid={details?.serialNo}>
            <div className={classes.downloadbars}>
                <div className={classes.downloadtopbar}>
                    <Row align={"middle"}>
                        <Col span={12} className={clsx(classes.downloadtopbarHeading)}>
                            <span>Original</span></Col>
                        <Col span={12} style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={clsx(classes.downloadtopbarHeading, classes.textAlignRight)}>
                            {details?.transferStatus === 'CREATED' ? 'Transfer Request' : 'Delivery Challan'}
                        </Col>
                    </Row>
                </div>
            </div>
            <div className={clsx(classes.ddfsection, classes.margin15t)}>
                <Row>
                    <Col span={12}>
                        <h1>{details?.business?.name || '---'}</h1>
                        <p>{address(details?.business)}</p>
                        <p>{address1(details?.business)}</p>
                        <Row className={clsx(classes.margin30t)}>
                            <Col span={12}>
                                <Row>
                                    <Col span={6}>
                                        <p>GSTIN</p>
                                    </Col>
                                    <Col span={18}>
                                        <p>{details?.business?.gstNumber || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row>
                                    <Col span={6}>
                                        <p>Ph No.</p>
                                    </Col>
                                    <Col span={18}>
                                        <p>{details?.business?.mobile || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row>
                                    <Col span={3}>
                                        <p>Email</p>
                                    </Col>
                                    <Col span={21}>
                                        <p className={clsx(classes.emailText)}>{details?.business?.email || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={12} className={classes.textAlignRight}>
                        <h1 className={classes.textAlignRight}>{details?.serialNo || '---'}</h1>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <h1>From Location</h1>
                        <p>{details?.location.name}</p>
                        <p>{address(details?.location)}</p>
                        <p>{address1(details?.location)}</p>
                    </Col>
                    <Col span={12} className={classes.textAlignRight}>
                        <h1 className={classes.textAlignRight}>To Location</h1>
                        <p className={classes.textAlignRight}>{details?.toLocation.name}</p>
                        <p className={classes.textAlignRight}>{address(details?.toLocation)}</p>
                        <p className={classes.textAlignRight}>{address1(details?.toLocation)}</p>
                    </Col>
                </Row>
            </div>
            <div className={clsx(classes.ddssection, classes.margin10t)}>
                <Row className={clsx(classes.alginitemNormal)}>
                    <Col span={12} className={clsx(classes.ddssectionpadding)} style={{ border: "none" }}>
                        <h6>Transport details</h6>
                        <p className={clsx(classes.margin25t)}>{details?.driverName || '---'}</p>
                        <p>Vehicle Number: {details?.vehicleNumber || '---'}</p>
                        <p>Mode of Transport: {details?.modeOfTransport || '---'}</p>
                        <p>Distance: {details?.distance || '---'}</p>
                    </Col>
                    <Col span={12} className={clsx(classes.ddssectionpadding, classes.textAlignRight)} style={{ border: "none" }}>
                        <h6>Date</h6>
                        <p className={clsx(classes.margin25t, classes.bold)}>{details?.shippedDate ? moment(details.shippedDate).format('DD MMM YYYY') : '---'}</p>
                    </Col>
                </Row>
            </div>
            <div className={clsx(classes.ddssection)} style={{ borderTop: "none" }}>
                <div className={clsx(classes.PlaceofSupply, classes.customDDssection)}>Place of Supply
                    <span className={classes.PlaceofSupplyText}>{details?.toLocation?.state?.name}</span></div>
                <div className={clsx(classes.thirdSection)}>
                    <Row className={clsx(classes.bill, classes.margin20t, classes.viewPrint)}>
                        <Col span={2}><h6>L. No.</h6></Col>
                        <Col span={6}><h6>Product Name</h6></Col>
                        <Col span={4}><h6>HSN Code</h6></Col>
                        <Col span={3} ><h6>Quantity | Unit</h6></Col>
                        <Col span={3} className={clsx(classes.textAlignRight)}><h6>Unit Price</h6></Col>
                        <Col span={3} className={clsx(classes.textAlignRight)}><h6>Amount</h6></Col>
                    </Row>
                    {
                        details && details?.stockTransferItems && details?.stockTransferItems?.length > 0 ? details?.stockTransferItems?.map((data, i) => (
                            <Row className={clsx(classes.bill, classes.viewPrint)} key={i}>
                                <Col span={2}><p>{i + 1}</p></Col>
                                <Col span={6}><p>{data.product?.productName || '---'}</p></Col>
                                <Col span={4}><p>{data.product?.hsn?.hsnCode || '---'}</p></Col>
                                <Col span={3}><p className={clsx(classes.disInline)}>{data.toQuantity}</p> <p className={clsx(classes.disInline, classes.textAlignRight)}>{data?.unit?.name || '---'}</p></Col>
                                <Col span={3} className={clsx(classes.textAlignRight)}><p> {`${data?.product?.costPrice ? currencyFormat(data?.product?.costPrice) : '---'}`}</p></Col>
                                <Col span={3} className={clsx(classes.textAlignRight)}><p> {`${data?.product?.costPrice ? currencyFormat(data.toQuantity * data?.product?.costPrice) : '---'}`}</p></Col>


                            </Row>
                        )) : <Row className={clsx(classes.bill, classes.viewPrint)}>
                            <Col span={24} className={classes.textAlignCenter}><p>No lines found</p></Col></Row>
                    }
                </div>
            </div>
            <div className={clsx(classes.ddssection)} style={{ borderTop: "none" }}>
                <div className={clsx(classes.ddssectionpadding, classes.padding55t)} style={{ border: "none" }}>
                    Authorized Signatory
                </div>
            </div>
        </div>
    )
}